'use strict';

window.ga =
	window.ga ||
	function () {
		console.error('GA is deprecated');
	};
